<template>
    <vs-card>
        <vs-alert active="true">
           El periodo lectivo ha caducado, favor comuníquese con el administrador del sistema.
            <vs-button class="ml-2" @click="salir()" type="relief">Salir</vs-button>
        </vs-alert>
    </vs-card>
  
</template>

<script>
export default {
  props: {
  },
    data() {
        return{
            usuario:[]
        }
    },
    created(){
        let me = this
        this.usuario = JSON.parse(localStorage.getItem('usuario'));
        if(localStorage.bloquear == 'no'){
            
         this.$router.push('/');
            
        }else{
            this.$router.push('/bloqueo');
            
        }

    },
    methods:{
        salir(){
            localStorage.clear()
            this.$router.push('/');
        },
       
    }
}
</script>